import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';


import './App.css';

import Login from './components/Login';
import Users from './components/Users';
import Policy from './components/Policy';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path='/' element = {<Login />} exact />
        <Route path='/remove-user' element = {<Users />} exact />
        <Route path='/policy' element = {<Policy />} exact />
      </Routes>
    </Router>
  );
}

export default App;
